import DeleteOutlined from '@mui/icons-material/DeleteOutlined';
import { Button, Grid, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';

interface Props {
  visitorName: string;
  visitorEmail?: string | null;
  isDeleteVisitorButtonVisible: boolean;
  handleOpenDeleteVisitorModal: () => void;
}

const Header: React.FC<Props> = ({
  visitorName,
  visitorEmail,
  isDeleteVisitorButtonVisible,
  handleOpenDeleteVisitorModal
}) => {
  const { translation } = useTranslation();

  return (
    <Grid container justifyContent="space-between">
      <Grid container direction="column">
        <Grid container spacing={2}>
          <Typography
            variant="h4"
            color="textPrimary"
            sx={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}
          >
            {visitorName}
          </Typography>
        </Grid>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', textWrap: 'nowrap' }}
        >
          {visitorEmail}
        </Typography>
      </Grid>
      {isDeleteVisitorButtonVisible && (
        <Button
          id="delete-user-button"
          onClick={handleOpenDeleteVisitorModal}
          size="small"
          color="error"
          variant="text"
          startIcon={<DeleteOutlined color="error" />}
        >
          {translation.delete_user}
        </Button>
      )}
    </Grid>
  );
};

export default Header;
